<template>
    <div class="user-stat-page-container">
        <div v-if="loading" class="d-flex justify-content-center m-2 tip_body" style="height: 10px;">
            <CSpinner
                color="info"
                style="width:4rem;height:4rem;"
            />
        </div>
        <CCard v-else>
            <CCardBody>
                <CDataTable
                    class="list-table"
                    :loading="loading"
                    sorter
                    tableFilter
                    hover
                    border
                    striped
                    outlined
                    :items="items" 
                    :fields="fields"                     
                 >
                     <template #pl="{item, index}">                       
                        <td>
                            <span :class="{'outcome-col': true, 'green-background' : parseFloat(item['pl']) > 0, 'red-background' : parseFloat(item['pl']) < 0}">{{item.pl}}</span>
                        </td>
                    </template>
                </CDataTable>


            </CCardBody>
        </CCard>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import Swal from 'sweetalert2';

    import ListTable from '@/components/ListTable';
    import {convertUTCToLocal, defaultFormat } from '@/helpers/time';

    export default {        
        components: {
            ListTable
        },
        data () {
            return {
                loading: false,
                items: [],
                fields: [
                  { key: 'start_time', label: 'Start time', _style:'' },
                  { key: 'country', label: 'country', _style:'' },
                  { key: 'league', label: 'league', _style:'' },
                  { key: 'event', label: 'event', _style:'' },
                  { key: 'prediction', label: 'prediction', _style:'' },
                  { key: 'side', label: 'side', _style:'' },
                  { key: 'stake', label: 'stake', _style:'' },
                  { key: 'entry_odd', label: 'entry odd', _style:'' },
                  { key: 'R/S', label: 'R/S', _style:'' },
                  { key: 'pl', label: 'P/L', _style:'' },
                ],
            }
        },
        computed: {
            ...mapGetters(['loggedInUser']),
        },
        methods: {
            ...mapActions([
                'getBetfairTips'                
            ]),
            init() {
                this.loading = true;
                
                const { id } = this.$route.params;                
                
                this.data = [];
                this.getBetfairTips({strategy: id}).then((data) => {

                    let tips = data.data;
                    console.log( 'tips', tips)                    
                    let items = [];
                    for ( var i=0; i<tips.length; i++ ) {
                        let item = {};
                        let simulation_mode = "R";
                        if (tips[i].betId == null)
                            simulation_mode = "S";
                        item['start_time'] = tips[i].betfairEvents[0].openDate;
                        let dateTime = convertUTCToLocal(tips[i].DailyFixtures[0].time.starting_at.date_time);
                        item['start_time'] = defaultFormat(dateTime);
                        item['country'] = tips[i].country;
                        item['league'] = tips[i].league;
                        item['event'] = tips[i].betfairEvents[0].eventName;
                        item['prediction'] = tips[i].predictionType;
                        item['side'] = tips[i].instruction.side;
                        item['stake'] = tips[i].sizeMatched;
                        item['entry_odd'] = parseFloat(tips[i].averagePriceMatched.toFixed(2));
                        item['pl'] = tips[i].profit;
                        item["R/S"] = simulation_mode;

                        if (tips[i].betfairCashouts.length > 0 && tips[i].betfairCashouts[0].profit) {
                            item['pl'] = parseFloat((tips[i].profit + tips[i].betfairCashouts[0].profit).toFixed(2));
                        }

                        items.push(item);                        
                    }
                    this.items = items;
                    
                }).finally(() => {
                    
                    this.loading = false;
                });
            },
            
        },
        watch: {
            '$route.params': {
                deep: true,
                immediate: true,
                handler(val) {
                    if(!this.loading)
                        this.init();
                }
            }
        },
        mounted() {
            let user_id = localStorage.getItem('user_id');
            this.userId = parseInt(user_id);
           
        },
        created() {
        },
        beforeDestroy() {
            
        }
    }
</script>
<style lang="scss" scoped>
   thead{
        background-color: #bae1aa !important ;
        background: #bae1aa !important ;
   }

   .list-table {
        ::v-deep  table {
            
            thead{
                background-color: #bae1aa !important;
            }            
        }
    }
    .outcome-col {
        color:  white;
        min-width: 35px;
        display: inline-block;
        border-radius: 5px;
    }
    .green-background {
        background-color:  green;
    }
    .red-background {
        background-color:  red;
    }

</style>